var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_5_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_5_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M375.2,333.3c-2,0-4,0-6,0.2c-2.8,0.4-1.9,3.8-1.9,5.9c0,1.7-0.5,4.4,1.3,5.4s5.2,0.6,7.2,0.8 c9.8,1.2,18.7,1,27.4,3.7c2,0.6,4,1.4,5.8,2.4c1.3,0.7,5.1,3.6,6.5,3.3c3.3-0.7-5-9-6.3-10.2c-7.5-6.9-16.2-10-26.2-11 C380.5,333.5,377.8,333.5,375.2,333.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M346.5,334c2,0,4,0,6,0.2c2.8,0.4,1.9,3.8,1.9,5.9c0,1.7,0.5,4.4-1.3,5.4s-5.2,0.6-7.2,0.8 c-9.8,1.2-18.7,1-27.4,3.7c-2,0.6-4,1.4-5.8,2.4c-1.3,0.7-5.1,3.6-6.5,3.3c-3.3-0.7,5-9,6.3-10.2c7.5-6.9,16.2-10,26.2-11 C341.3,334.3,343.9,334.2,346.5,334"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M337,425.5L337,425.5L337,425.5C337,425.6,337,425.6,337,425.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M398.5,391c-4.7,2.6-10.1,3.9-15.2,4.7c-5.7,0.9-13.9-1.1-19.3-1.5c-5.9-0.4-9.5,0.5-15.1,1.8 c-5.4,1.3-10,2.5-15.6,0.9c-4.9-1.4-9.4-3.5-14.2-5.6c-3.9-1.7-7.8-3.4-11.3-5.6c3.3,3.5,5,8.3,8.1,12c3.3,4,7,7,9.9,11.4 c2.2,3.3,4.8,6,4.5,10.4c2.5-2.9,3.5-5,3.1-8.8c2.9,2.7,5,11.1,3.7,14.9c3.4-1.9,5.8-4.4,7.2-8c0.7,3.9,0,9.4-2.8,12.5 c3.8-0.9,9.2-3.7,11-7.7c0.9,6.6,2.3,10.3,8.3,14.1c3.9-4,8.6-6.8,10.9-12.6c0.8,3.4,1.3,6.6,4.6,8.4c-0.6-4.5,0.6-10.7,1.8-15 c0.2,3.3,1.3,6.5,3.7,8.8c1.2-4.6,5.4-9.2,8.5-12.8c3.4-3.9,6.5-8,10-11.9c2.5-2.8,4.9-5.8,7.1-8.8c1.4-1.9,4.5-5.6,5.4-7.1 C406.1,386.9,403.1,388.4,398.5,391z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard5A);
export default __webpack_public_path__ + "static/media/man_beard_5a.e7117730209eb02502af410d9f8af6b4.svg";
export { ForwardRef as ReactComponent };